exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  text-align: center;\n  max-width: 327px; }\n\n.form-group {\n  margin-bottom: 12px; }\n\ninput.req {\n  border-left: 5px solid #e62700 !important; }\n\n::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: #e62700;\n  font-style: italic; }\n\n::-moz-placeholder {\n  /* Firefox 19+ */\n  color: #e62700;\n  font-style: italic; }\n\n:-ms-input-placeholder {\n  /* IE 10+ */\n  color: #e62700;\n  font-style: italic; }\n\n:-moz-placeholder {\n  /* Firefox 18- */\n  color: #e62700;\n  font-style: italic; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/site-admin/company/sites/site-new/site-new.component.scss
// module id = ../../../../../src/app/views/site-admin/company/sites/site-new/site-new.component.scss
// module chunks = main